import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { App as CapacitorApp } from "@capacitor/app";
import { BASE, LOGIN, SIGNUP } from "./routes";

export default function BackButtonHandler() {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const exitRoutes = [BASE, LOGIN, SIGNUP];

        const handler = CapacitorApp.addListener("backButton", () => {
            const currentPath = location.pathname;
            const popupOpen = window.history?.state?.attendancePopup === true;

            if (popupOpen) {
                window.history.back();
                return;
            }

            if (exitRoutes.includes(currentPath)) {
                CapacitorApp.exitApp();
            } else {
                navigate(-1);
            }
        });

        return () => {
            handler.remove();
        };
    }, [navigate, location]);

    return null;
}
